import { I18n } from "@/i18n/I18n";
import { CUSTOM_FIELD_TYPES } from "@/types/customFieldTypes";
import { ParameterInputType } from "@/types/parameterTypes";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { BasicButton } from "../buttons/BasicButton";
import { FieldTypeSelect } from "../parameters/FieldTypeSelect";
import { InputTypeSelect } from "../parameters/InputTypeSelect";


export function CustomFieldAddButton(props: {
  onClick: (fieldType: CUSTOM_FIELD_TYPES, inputType: ParameterInputType) => void;
  label: string;
}) {
  const { onClick, label } = props;
  const [showParameterModal, setShowParameterModal] = useState<boolean>(false);
  const [fieldType, setFieldType] = useState<CUSTOM_FIELD_TYPES | null>(null);
  const [fieldTypeError, setFieldTypeError] = useState<string>();
  const [inputType, setInputType] = useState<ParameterInputType>(ParameterInputType.FREE_FORM);

  const handleSave = async () => {
    if (!fieldType) {
      setFieldTypeError(I18n.get('fieldTypeRequired'));
      return;
    }

    onClick(fieldType, inputType);
    handleClose();
  };

  const onFieldSelect = (selectedFieldType: CUSTOM_FIELD_TYPES) => {
    setFieldType(selectedFieldType);
    setFieldTypeError('');
  };

  const handleClose = () => {
    setShowParameterModal(false);
    setFieldType(null);
    setFieldTypeError('');
    setInputType(ParameterInputType.FREE_FORM);
  };

  const typeOptions = [
    CUSTOM_FIELD_TYPES.String,
    CUSTOM_FIELD_TYPES.MultilineText,
    CUSTOM_FIELD_TYPES.Integer,
    CUSTOM_FIELD_TYPES.Float,
    CUSTOM_FIELD_TYPES.Boolean,
    CUSTOM_FIELD_TYPES.File,
  ];

  return (
  <>
    <div className='d-flex'>
    <BasicButton
        onClick={() => setShowParameterModal(true)}
        label={label}
      />
    </div>
    {showParameterModal &&  <Modal size="sm" show onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.get('createFieldInput')}</Modal.Title>
      </Modal.Header >
      <Modal.Body>
       <div>
          <FieldTypeSelect
            disabled={false}
            fieldType={fieldType}
            onFieldSelect={onFieldSelect}
            typeOptions={typeOptions}
          />
          { fieldTypeError && <div className='text-danger'>{fieldTypeError}</div> }
          <InputTypeSelect
            inputType={inputType}
            setInputType={setInputType}
            disabled={false}
            typeOptions={[ParameterInputType.FREE_FORM, ParameterInputType.SINGLE_CHOICE, ParameterInputType.MULTIPLE_CHOICE]}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{I18n.get('cancel')}</Button>
        <Button type="submit" variant="primary" onClick={() => void handleSave()}>{I18n.get('confirm')}</Button>
      </Modal.Footer>
    </Modal>}
  </>
  );
}
